module.exports = __webpack_public_path__ + "static/media/Octopus.8ad8a395.svg";